import { VanillaFadeToggle, VanillaSlideToggle } from '../plugins/workshop/ws-display-toggle.js-v1.0.1/src/index';

var mobileNyrdcButton = document.getElementById("main_menu_mobile_nyrdc");
var header_appendix = document.querySelector('.bottom-logos .header__appendix');
var audience_block = document.getElementById('block-audiencenavigation-2');

var SlideToggle = new VanillaSlideToggle();
var FadeToggle = new VanillaFadeToggle();

if (mobileNyrdcButton) {
  mobileNyrdcButton.addEventListener('click', function() {
    var button = this;
    mobileNyrdcButton.classList.toggle('active');
    SlideToggle.slideToggle(header_appendix, 500);
  });
}

